export const requestIdleCallback =
  window.requestIdleCallback ||
  window.requestAnimationFrame ||
  function (cb) {
    return setTimeout(cb, 1);
  };
